export default __webpack_public_path__ + "static/media/cross.49fd0974.svg";